<template>
  <div v-if="$store.state.readyState" id="app">
    <Nav/>
    <transition
        name="fade"
        mode="out-in"
      >
        <router-view/>
      </transition>
  </div>
</template>
<script>
import Nav from '@/components/Nav'
import jQuery from 'jquery'
export default {
    components: {
        Nav
    },
    data() {
        return {
            launchesApiUrl: 'https://api.spacexdata.com/v3/launches/past',
            nextLaunchApiUrl: 'https://api.spacexdata.com/v3/launches/next',
            missionsApiUrl: 'https://api.spacexdata.com/v3/missions',
            rocketsApiUrl: 'https://api.spacexdata.com/v3/rockets'
        }
    },
    created() {
        this.$store.dispatch('fetchLaunches', this.launchesApiUrl)
        this.$store.dispatch('fetchNextLaunch', this.nextLaunchApiUrl)
        this.$store.dispatch('fetchMissions', this.missionsApiUrl)
        this.$store.dispatch('fetchRockets', this.rocketsApiUrl)
        
    },
    mounted() {
        window.addEventListener('load', () => {
            window.$ = jQuery;
        });
    }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
